<section [ngClass]="customClass">
  <header class="top-level">
      <div class="information">
        <h2>¡Una buena <span class="break">comunicación es la clave!</span></h2>
        <span>Elija como lo contactamos, acorde a la Ley 2300 de 2023</span>
      </div>
  </header>
  <div class="middle-level">
    <div class="card">
      <h2>Actualice su información</h2>
      <span>De acuerdo con la Ley 2300 de 2023, usted podrá actualizar los canales por los que desea recibir
        alternativas de pagos e información comercial relevante.</span>
    </div>
  </div>
  <div class="form-level">
    <form [formGroup]="form" class="form">
      <div class="info-1">
        <h3>Ingrese sus datos:</h3>
        <span>Por favor diligencie toda la información.</span>
        <p>Todos los campos con * son obligatorios.</p>
      </div>

      <div class="group-name">
        <div class="flex flex-column gap-2" [ngClass]="{'field-has-error': errorName, 'field': !errorName}">
          <label for="name" *ngIf="slName">{{lName}}</label>
          <input pInputText id="name" aria-describedby="name-error" formControlName="name"
            [placeholder]="phName" maxlength="60"/>
          <small id="name-error" *ngIf="errorName">
            <i class="pi pi-exclamation-circle" *ngIf="this.domain === 'ciencuadras'"></i>{{errorNName}}
          </small>
        </div>

        <div class="flex flex-column gap-2" [ngClass]="{'field-has-error': errorLastName, 'field': !errorLastName}">
          <label for="username" *ngIf="slLastName">{{lLastName}}</label>
          <input pInputText id="username" aria-describedby="lastName-error" formControlName="lastName"
            [placeholder]="phLastName" maxlength="60"/>
          <small id="lastName-error" *ngIf="errorLastName">
            <i class="pi pi-exclamation-circle" *ngIf="this.domain === 'ciencuadras'"></i>{{errorNLastName}}
          </small>
        </div>

        <div class="flex flex-column gap-2" [ngClass]="{'field-short-has-error': errorDocumentType, 'field-short': !errorDocumentType}">
          <label for="username" *ngIf="slDocumentType">{{lDocumentType}}</label>
          <p-treeSelect placeholder="Tipo de documento" [options]="documentTypes" formControlName="documentType" (onHide)="hasError('documentType')" aria-describedby="documentType-error" />
          <small id="documentType-error" *ngIf="errorDocumentType">
            <i class="pi pi-exclamation-circle"></i>{{errorNDocumentType}}
          </small>
        </div>

        <div class="flex flex-column gap-3 field-medium">
          <div [ngClass]="{'hasError': errorDocumentNumber, 'input-field': !errorDocumentNumber}">
            <label for="username" *ngIf="slDocumentNumber">{{lDocumentNumber}}</label>
            <p-inputNumber id="documentNumber" class="input-number" inputId="locale-german" mode="decimal" locale="de-DE" [minFractionDigits]="0" formControlName="documentNumber" [placeholder]="phDocumentNumber" maxlength="15" (onInput)="changePage($event.value, 'documentNumber')" aria-describedby="documentNumber-error" />
            <small id="documentNumber-error" *ngIf="errorDocumentNumber">
              <i class="pi pi-exclamation-circle" *ngIf="this.domain === 'ciencuadras'"></i>{{errorNDocumentNumber}}
            </small>
          </div>
        </div>
        <div class="flex flex-column gap-2 field-group" [ngClass]="{'field-has-error': errorEmail, 'field': !errorEmail}">
          <div class="input-field">
            <label for="username" *ngIf="slEmail">{{lEmail}}</label>
            <input type="text" class="input" pInputText id="email" formControlName="email" [placeholder]="phEmail" aria-describedby="email-error" />
            <small id="email-error" *ngIf="errorEmail">
              <i class="pi pi-exclamation-circle" *ngIf="this.domain === 'ciencuadras'"></i>{{errorNEmail}}
            </small>
          </div>
        </div>
        <div class="flex flex-column gap-2 field-group" [ngClass]="{'field-has-error': errorPhone, 'field': !errorPhone}">
          <div class="input-field">
            <label for="username" *ngIf="slPhone">{{lPhone}}</label>
            <p-inputMask 
              mask="999-999-9999" 
              id="phone"
              formControlName="phone"
              [placeholder]="phPhone"
              aria-describedby="phone-error" />
              <small id="phone-error" *ngIf="errorPhone">
                <i class="pi pi-exclamation-circle" *ngIf="this.domain === 'ciencuadras'"></i>{{errorNPhone}}
              </small>
          </div>
        </div>
      </div>

      <hr class="custom-divider">

      <div class="info-2">
        <h3>Elija sus canales de preferencia:</h3>
        <span class="span-1">Por favor diligencie toda la información.</span>
        <p>Todos los campos con * son obligatorios.</p>
        <span class="span-2">Para recibir <span>alternativas de pago de tus obligaciones</span>, indica tu canal favorito y uno
          complementario:</span>
      </div>

      <div [ngClass]="{'select-channel-has-error': errorChannel, 'select-channel': !errorChannel}">
        <label for="username" *ngIf="slChannel">{{phChannel}}</label>
        <p-treeSelect [placeholder]="phChannel" [options]="channelTypes"
          formControlName="channelType" (onNodeSelect)="selectChannelEvent($event)" (onHide)="hasError('channelType')" aria-describedby="channelType-error"/>
          <small id="channelType-error" *ngIf="errorChannel">
            <i class="pi pi-exclamation-circle"></i>{{errorNChannel}}
          </small>
      </div>

      <div class="complementary-channel" *ngIf="complementaryChannel">
        <span>Canal complementario: <span>{{complementaryChannel}}</span></span>
      </div>

      <span class="contact">Para recibir <span>información comercial relevante</span>, selecciona mínimo 2 canales de
        contacto:</span>

      <div class="checkbox-contact">
        <div class="item">
          <p-checkbox formControlName="email_contact" [binary]="true" inputId="binary"></p-checkbox>
          <label>Correo electrónico</label>
        </div>

        <div class="item">
          <p-checkbox formControlName="call_contact" [binary]="true" inputId="binary"></p-checkbox>
          <label>Llamada</label>
        </div>

        <div class="item">
          <p-checkbox formControlName="sms_contact" [binary]="true" inputId="binary"></p-checkbox>
          <label>Mensaje de texto</label>
        </div>

        <div class="item">
          <p-checkbox formControlName="whatsapp_contact" [binary]="true" inputId="binary"></p-checkbox>
          <label>Whatsapp</label>
        </div>

      </div>

      <div class="info-additional">
        <p class="part-1">Te informamos que para contactarte daremos cumplimiento a los días, horas y periodicidad
          establecidos por la ley. Esta comunicación la estamos generando de acuerdo a la <span>Ley 2300 de 2023</span>
        </p>
        <p class="part-2">*En caso de no actualizar sus canales, entenderemos que nos autoriza a seguir comunicándonos
          por los canales previamente autorizados por usted como son: correo electrónico, llamada, mensaje de texto,
          Whatsapp.</p>
      </div>

      <div class="politics">
        <p-checkbox formControlName="politics" [binary]="true" inputId="binary"></p-checkbox>
        <p *ngIf="domain === 'servicios-bolivar'">He le&iacute;do y autorizo el tratamiento de mis datos personales de acuerdo con la <button class="event button-as-text" (click)="openPolicies()">Política de Tratamiento de Datos Personales</button></p>
        <p *ngIf="(domain !== 'jelpit' && domain !== 'ciencuadras' && domain !== 'servicios-bolivar')">He leido la <button class="event button-as-text" (click)="openPolicies()">Política de Privacidad</button> y
              autorizo el <button class="event button-as-text" (click)="openMyDataPermission()">Tratamiento de mis Datos
                Personales</button></p>
        <p *ngIf="(domain === 'jelpit' || domain === 'ciencuadras')"> He leído y autorizo el tratamiento de mis datos personales de acuerdo con la
          <button class="event button-as-text" (click)="openPolicies()">Política de Tratamiento de Datos Personales</button></p>
      </div>

      <div class="politics">
        <p-checkbox formControlName="terms" [binary]="true" inputId="binary"></p-checkbox>
        <p *ngIf="(domain !== 'jelpit' && domain !== 'ciencuadras' && domain !== 'servicios-bolivar')">Autorizo de manera expresa la utilización 
          de mis datos personales para el envío de <button class="event button-as-text" (click)="openDataAuthorizationTreatment()">información y ofertas comerciales</button></p>
        <p *ngIf="(domain === 'jelpit' || domain === 'ciencuadras' || domain === 'servicios-bolivar')"> Autorizo el envío de 
          <button class="event button-as-text" (click)="openMyDataPermission()">información publicitaria y ofertas comerciales.</button>
        </p>
      </div>

      <div class="btn">
        <button (click)="sendForm()" [disabled]="!validateForm()">Enviar</button>
      </div>

    </form>
  </div>

  <p-dialog [modal]="true" [(visible)]="visibleMyDataPermission">
    <div class="dialog-permission">
      <span>AUTORIZACIÓN PARA LA UTILIZACIÓN DE LOS DATOS PERSONALES (LEY 1581 DE 2012):</span>
      <p>
        Autorizo a COMPAÑÍA DE SEGUROS BOLÍVAR S.A., y  SEGUROS COMERCIALES BOLÍVAR S.A, (en adelante La “Compañía”), 
        para que traten mis datos personales entregados en este formulario y a los que llegue a acceder La Compañía 
        como consecuencia de la adquisición de productos y/o servicios a través de este medio, así como cualquier otro 
        dato que entregue a través de los canales de atención: físicos, telefónicos, virtuales y digitales puestos a mi 
        disposición o que usa La Compañía para contactarse conmigo, al hacer uso de los productos y/o recibir los 
        servicios correspondientes. Entiendo y acepto que los fines con los que serán utilizados mis datos son: 
        <strong>1.</strong> Enviarme comunicaciones o mensajes relacionados con los productos y/o servicios adquiridos. 
        <strong>2.</strong> Desarrollar las actividades propias de los contratos celebrados con la Compañía y el envío de información 
        relevante para el desarrollo de dichos contratos <strong>3.</strong> Medir el nivel de satisfacción respecto del(los) 
        producto(s) y/o servicio(s) contratados(s). <strong>4.</strong> Realizar investigación y análisis estadístico para el 
        mejoramiento de productos y/o servicios.
      </p>

      <p>
        En el caso en que como parte de la adquisición de productos y/o servicios de La Compañía, sea necesario 
        proporcionar información relacionada con mi estado de salud, o mi historia clínica la cual puede ser considerada 
        información sensible, entiendo que dicha información se proporcionará exclusivamente con la finalidad 
        desarrollar actividades propias de los contratos celebrados con La Compañía y especialmente como consecuencia 
        de mi calidad de asegurado/beneficiario, por lo que declaro y entiendo que la autorización de dicha información es facultativa.
      </p>

      <p>
        En el caso de haber incluido beneficiarios y/o asegurados adicionales en los contratos celebrados con la Compañía, 
        manifiesto que los datos personales suministrados son los necesarios para que éstos adquieran tal calidad y 
        puedan así beneficiarse de la cobertura del seguro, bajo el amparo de la figura de estipulación a favor de otro; 
        en el evento en que se trate de información de menores de edad, la suministró en calidad de representante legal 
        y en ejercicio de la patria potestad,  atendiendo al interés superior y protección del menor, y especialmente a 
        su calidad de asegurado/beneficiario de los productos y/o servicios adquiridos. 
      </p>

      <p>
        <strong>DERECHOS DEL TITULAR DE LA INFORMACIÓN Y CANALES DE ATENCIÓN:</strong> Como titular de la información tengo derecho a conocer, 
        actualizar, rectificar y suprimir la información personal que haya suministrado, esto último siempre y cuando no exista un deber 
        legal y/o contractual. Los canales a través de los cuales puede ejercerlos son: <strong>Telefónico:</strong> Desde el celular marque #322 ó Desde 
        cualquier teléfono la línea 018000123322 y en Bogotá  al 3122122 <strong>WhatsApp:</strong> (322)3322322 <strong>Virtual: </strong>  
        <a href="https://www.segurosbolivar.com">www.segurosbolivar.com</a> Y por aquellos que sean puestos a disposición en la Política de Privacidad
        <a href="https://d9b6rardqz97a.cloudfront.net/wp-content/uploads/2024/02/16112906/240213_transv_5335_15Feb24.pdf">https://d9b6rardqz97a.cloudfront.net/wp-content/uploads/2024/02/16112906/240213_transv_5335_15Feb24.pdf</a>
      </p>

      <div class="btn">
        <button (click)="visibleMyDataPermission = false">Cerrar</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="visibleMyDataPermissionServicios">
    <div class="dialog-permission">
      <div *ngIf="(domain === 'jelpit' || domain === 'ciencuadras' || domain === 'servicios-bolivar')">
      <p>
      En la medida en que me encuentro interesado en recibir información comercial y publicitaria, autorizo a Servicios Bolívar S.A. 
      a utilizar los datos personales que he proporcionado con las finalidades de:
      </p>
        <p><span>1-</span>Realizar campañas comerciales y actividades de mercadeo.</p>
        <p><span>2-</span>Contactarme por cualquier medio para realizar investigaciones de mercados.</p>
        <p><span>3-</span>Contactar, enviar y/o suministrar información sobre el lanzamiento de sus productos, eventos, novedades, promociones, y 
        publicidad mediante el uso de e-mail, correo postal, teléfono, celular, mensajes cortos de texto (SMS), mensajes de multimedia (MMS), 
        redes sociales, Apps o medios similares que habilite Servicios Bolívar.</p>
        <p><span>4-</span>Realizar actividades de analítica(1), procesamiento, investigación y análisis estadístico, con el fin de identificar, 
        generar conocimientos encaminados a mejorar los productos y/o servicios ofrecidos, actuales o futuros, así como mi experiencia 
        de usuario y/o cliente; y a la identificación, ofrecimiento y/o desarrollo de posibles ofertas de valor, bienes, productos y/o 
        servicios del portafolio que podrían adecuarse a mis necesidades. Entiendo que dichas actividades comprenden igualmente la generación 
        de datos inferidos, que corresponden a aquellos obtenidos a partir del procesamiento analítico de mis datos personales, mis interacciones 
        con los diferentes canales de la Compañía, hábitos, preferencias, tendencias y comportamientos como usuario y/o cliente.</p>
        <hr>
        <br>
        <p>
          <span>(1)</span> Entendido como el proceso de examinar conjuntos de datos para encontrar tendencias y/o patrones, realizar perfilamiento de clientes y/o usuarios 
          y sacar conclusiones sobre la información que contienen.
        </p>
      </div>
      <span>AUTORIZACIÓN PARA COMPARTIR DATOS CON EMPRESAS DEL GRUPO BOLÍVAR</span>
      <p>
        Autorizo a SERVICIOS BOLÍVAR S.A. a compartir mis datos personales y los datos inferidos que corresponden a 
        aquellos obtenidos a partir del procesamiento analítico de mis datos personales, mis interacciones con los diferentes 
        canales de la Compañía, hábitos, preferencias, tendencias y comportamientos como usuario y/o cliente, con las demás 
        entidades del Grupo Empresarial Bolívar cuya matriz es GRUPO BOLÍVAR S.A., las cuales están listadas en la página web 
        <a>>www.grupobolivar.com.co</a> y son actualizadas periódicamente, a efecto que dichas empresas utilicen esta información para 
        adelantar actividades de analítica, procesamiento, investigación, análisis estadístico y puedan realizar el tratamiento 
        de esta información y/o me contacten mediante el uso de correo electrónico, correo postal, teléfono fijo, celular, 
        mensajes cortos de texto (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) o medios 
        similares que habilite la Compañía, para realizar campañas comerciales, publicitarias, marketing, ofrecimiento de ofertas 
        de valor, bienes, productos y/o servicios.
      </p>
      <span>AUTORIZACIÓN PARA COMPARTIR DATOS CON ALIADOS</span>
      <p>
        Autorizo a SERVICIOS BOLÍVAR S.A. a compartir mis datos personales y los datos inferidos que corresponden a aquellos obtenidos 
        a partir del procesamiento analítico de mis datos personales, mis interacciones con los diferentes canales de la Compañía, hábitos, 
        preferencias, tendencias y comportamientos como usuario y/o cliente, con los aliados comerciales y estratégicos, los cuales serán comunicados 
        por las Compañías del Grupo Bolívar, a efecto de que dichos aliados utilicen esta información para adelantar actividades de analítica, procesamiento, 
        investigación, análisis estadístico y puedan realizar el tratamiento de esta información y/o me contacten mediante el uso de correo electrónico, 
        correo postal, teléfono fijo, celular, mensajes cortos de texto (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) 
        o medios similares que habilite la Compañía, para realizar campañas comerciales, publicitarias, marketing, ofrecimiento de ofertas de valor, 
        bienes, productos y/o servicios.
      </p>
      <span>DERECHOS DEL TITULAR DE LA INFORMACIÓN</span>
      <p>
        Son derechos del Titular de la Información: conocer, actualizar, rectificar y revocar la autorización. Esto último salvo 
        disposición legal o contractual que impida la supresión. Para este fin, Servicios Bolívar  pone a disposición el siguiente 
        canal de comunicación: Correo electrónico: <a href="mailto:datospersonales@serviciosbolivar.com">datospersonales@serviciosbolivar.com</a>
      </p>
      <div class="btn">
        <button (click)="visibleMyDataPermission = false">Cerrar</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="visibleDataAuthorizationTreatment">
    <div class="dialog-treatment">
      <p>En la medida en que me encuentro interesado en recibir información comercial, autorizo a las Compañías a utilizar los 
        datos personales que he proporcionado con las finalidades de:</p>
      <div class="numbered-section">
        <div class="item-number">1.</div>
        <div class="item-content">
            <span class="bold-intro">Realizar campañas comerciales y actividades de mercadeo.</span> 
            Realizar contactos referentes a investigaciones de mercados. Contactar, enviar y/o suministrar información 
            sobre el lanzamiento de sus productos, eventos, novedades, promociones, y publicidad mediante el uso de correo electrónico, 
            correo postal, teléfono fijo, celular, mensajes cortos de texto (SMS), mensajes de multimedia (MMS), redes sociales, 
            aplicaciones móviles (Apps) o medios similares que habiliten las Compañías. Realizar actividades de analítica<span class="footnote-ref">1</span>, 
            procesamiento, investigación y análisis estadístico, con el fin de identificar,  generar conocimientos encaminados a mejorar los productos y/o 
            servicios ofrecidos, actuales o futuros, así como mi experiencia de usuario y/o cliente; y a la identificación, ofrecimiento y/o 
            desarrollo de posibles ofertas de valor, bienes, productos y/o servicios del portafolio que podrían adecuarse a mis necesidades. 
            Entiendo que dichas actividades comprenden igualmente la generación de datos inferidos, que corresponden a aquellos obtenidos a 
            partir del procesamiento analítico de mis datos personales, mis interacciones con los diferentes canales de la Compañía, hábitos, 
            preferencias,  tendencias  y comportamientos como usuario y/o cliente.   Autorización de reactivación: Para tratar mi información 
            personal, una vez se haya(n) terminado el(los) contrato(s) suscrito(s) con Las Compañías, con el fin único y específico de informarme 
            sobre productos y/o servicios que me puedan interesar y que permitan reactivar mi vínculo comercial. En el evento en que se reactive 
            la vinculación comercial, autorizo para que mi información siga siendo tratada para todas las finalidades previstas en este formato de 
            autorización que a la fecha acepto y suscribo. En todo caso, se me ha informado que puedo revocar esta autorización de reactivación en 
            cualquier momento, por medio de los canales para atender reclamos indicados en este documento. 
        </div>
    </div>

     <div class="footer-section"></div>
        <div class="footnote-text">
        <span class="footnote-number">1</span>
        <div>
            Entendido como el  proceso de examinar conjuntos de datos para encontrar tendencias y/o patrones, realizar perfilamiento 
            de clientes y/o usuarios y sacar conclusiones sobre la información que contienen.
        </div>
    </div>

    <div class="numbered-section">
        <div class="item-number">2.</div>
        <div class="item-content">
            <span class="bold-intro">Compartir datos con empresas del  GRUPO BOLÍVAR.</span> 
            Autorizo a las Compañías a compartir mis datos personales y los datos inferidos que corresponden a aquellos obtenidos a 
            partir del procesamiento analítico de mis datos personales, mis interacciones con los diferentes canales de la Compañía, 
            hábitos, preferencias, tendencias y comportamientos como usuario y/o cliente, con las demás entidades del Grupo Empresarial 
            Bolívar cuya matriz es GRUPO BOLÍVAR S.A., las cuales están listadas en la página web www.grupobolivar.com.co y son actualizadas 
            periódicamente, a efecto que dichas empresas utilicen esta información para adelantar actividades de analítica, procesamiento, 
            investigación, análisis estadístico y puedan realizar el tratamiento de esta información y/o me contacten mediante el uso de 
            correo electrónico, correo postal, teléfono fijo, celular, mensajes cortos de texto (SMS), mensajes de multimedia (MMS), 
            redes sociales, aplicaciones móviles (Apps) o medios similares que habilite la Compañía, para realizar campañas comerciales, 
            publicitarias, marketing, ofrecimiento de ofertas de valor, bienes, productos y/o servicios, así como para desarrollar 
            actividades de conocimiento del cliente.
        </div>
    </div>

    <div class="numbered-section">
        <div class="item-number">3.</div>
        <div class="item-content">
            <span class="bold-intro">Compartir datos con Aliados:</span> 
            Autorizo a las Compañías a compartir mis datos personales y los datos inferidos que corresponden a aquellos obtenidos 
            a partir del procesamiento analítico de mis datos personales, mis interacciones con los diferentes canales de la Compañía, 
            hábitos, preferencias, tendencias y comportamientos como usuario y/o cliente, con los aliados comerciales y estratégicos, 
            los cuales serán comunicados por las Compañías del Grupo Bolívar, a efecto de que dichos aliados utilicen esta información 
            para adelantar actividades de analítica, procesamiento, investigación, análisis estadístico y puedan realizar el tratamiento 
            de esta información y/o me contacten mediante el uso de correo electrónico, correo postal, teléfono fijo, celular, mensajes 
            cortos de texto (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) o medios similares que 
            habilite la Compañía, para realizar campañas comerciales, publicitarias, marketing, ofrecimiento de ofertas de valor, 
            bienes, productos y/o servicios.
        </div>
    </div>

      <div class="btn">
        <button (click)="visibleDataAuthorizationTreatment = false">Cerrar</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="visibleAuth">
    <div [ngClass]="customAuth">
      <span class="title">Autorización Tratamiento de datos personales</span>
      <p>
        <span>1. Realizar campañas comerciales y actividades de mercadeo.</span> Realizar contactos referentes a investigaciones de
        mercados. Contactar, enviar y/o suministrar información sobre el lanzamiento de sus productos, eventos,
        novedades,
        promociones, y publicidad mediante el uso de correo electrónico, correo postal, teléfono fijo, celular, mensajes
        cortos de texto (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) o medios
        similares que habiliten las Compañías. Realizar actividades de analítica1, procesamiento, investigación y
        análisis
        estadístico, con el fin de identificar, generar conocimientos encaminados a mejorar los productos y/o servicios
        ofrecidos, actuales o futuros, así como mi experiencia de usuario y/o cliente; y a la identificación,
        ofrecimiento
        y/o desarrollo de posibles ofertas de valor, bienes, productos y/o servicios del portafolio que podrían
        adecuarse
        a mis necesidades. Entiendo que dichas actividades comprenden igualmente la generación de datos inferidos, que
        corresponden a aquellos obtenidos a partir del procesamiento analítico de mis datos personales, mis
        interacciones
        con los diferentes canales de la Compañía, hábitos, preferencias, tendencias y comportamientos como usuario y/o
        cliente. Autorización de reactivación: Para tratar mi información personal, una vez se haya(n) terminado el(los)
        contrato(s) suscrito(s) con Las Compañías, con el fin único y específico de informarme sobre productos y/o
        servicios que me puedan interesar y que permitan reactivar mi vínculo comercial. En el evento en que se reactive
        la vinculación comercial, autorizo para que mi información siga siendo tratada para todas las finalidades
        previstas en este formato de autorización que a la fecha acepto y suscribo. En todo caso, se me ha informado que
        puedo revocar esta autorización de reactivación en cualquier momento, por medio de los canales para atender
        reclamos indicados en este documento.
      </p>

      <p class="information">
        1 Entendido como el proceso de examinar conjuntos de datos para encontrar tendencias y/o patrones, realizar
        perfilamiento de clientes y/o usuarios y sacar conclusiones sobre la información que contienen.
      </p>

      <p>
        <span>2. Compartir datos con empresas del GRUPO BOLÍVAR.</span> Autorizo a las Compañías a compartir mis datos personales y
        los
        datos inferidos que corresponden a aquellos obtenidos a partir del procesamiento analítico de mis datos
        personales, mis interacciones con los diferentes canales de la Compañía, hábitos, preferencias, tendencias y
        comportamientos como usuario y/o cliente, con las demás entidades del Grupo Empresarial Bolívar cuya matriz es
        GRUPO BOLÍVAR S.A., las cuales están listadas en la página web www.grupobolivar.com.co y son actualizadas
        periódicamente, a efecto que dichas empresas utilicen esta información para adelantar actividades de analítica,
        procesamiento, investigación, análisis estadístico y puedan realizar el tratamiento de esta información y/o me
        contacten mediante el uso de correo electrónico, correo postal, teléfono fijo, celular, mensajes cortos de texto
        (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) o medios similares que habilite
        la Compañía, para realizar campañas comerciales, publicitarias, marketing, ofrecimiento de ofertas de valor,
        bienes, productos y/o servicios, así como para desarrollar actividades de conocimiento del cliente.
      </p>

      <p>
        <span>3. Compartir datos con Aliados:</span> Autorizo a las Compañías a compartir mis datos personales y los datos inferidos
        que corresponden a aquellos obtenidos a partir del procesamiento analítico de mis datos personales, mis
        interacciones con los diferentes canales de la Compañía, hábitos, preferencias, tendencias y comportamientos
        como
        usuario y/o cliente, con los aliados comerciales y estratégicos, los cuales serán comunicados por las Compañías
        del Grupo Bolívar, a efecto de que dichos aliados utilicen esta información para adelantar actividades de
        analítica, procesamiento, investigación, análisis estadístico y puedan realizar el tratamiento de esta
        información
        y/o me contacten mediante el uso de correo electrónico, correo postal, teléfono fijo, celular, mensajes cortos
        de
        texto (SMS), mensajes de multimedia (MMS), redes sociales, aplicaciones móviles (Apps) o medios similares que
        habilite la Compañía, para realizar campañas comerciales, publicitarias, marketing, ofrecimiento de ofertas de
        valor, bienes, productos y/o servicios.
      </p>

      <div class="btn">
        <button (click)="visibleAuth = false">Cerrar</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="visibleSaveNotification">
    <div [ngClass]="customSaveNotification">
      <div class="icon-container">
        <div class="icon">
          <i class="pi pi-check" style="font-size: 2rem"></i>
        </div>
      </div>

      <div class="image-container">
        <img [src]="saveImage" alt="">
      </div>

      <span class="">Recibimos tu solicitud</span>
      <p>Te seguiremos enviando nuestros comunicados por los canales que elegiste.</p>
      
      <div class="btn">
        <button (click)="visibleSaveNotification = false">Listo</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="visibleErrorNotification">
    <div [ngClass]="customErrorNotificaction">
      <div class="icon-container">
        <div class="icon">
          <i class="pi pi-times" style="font-size: 2rem"></i>
        </div>
      </div>

      <div class="image-container">
        <img [src]="errorImage" alt="">
      </div>

      <span class="">¡Ups! Se están presentando dificultades</span>
      <p>Por favor intente en unos minutos o consulte más <span>información</span> de su producto en nuestro <span>Whatsapp</span> o llámenos al <span>#322</span>.</p>
      
      <div class="btn">
        <button (click)="visibleErrorNotification = false">Reintentar</button>
      </div>
    </div>
  </p-dialog>
</section>